import { AxiosResponse } from "axios";
import Axios, { Response } from "../utils/Axios";
import { RequestOrderProudctType } from "../recoil/type";
import { getRecoil } from "recoil-nexus";
import { qrAuthState } from "../recoil/auth";
const ApiController = {
  store: {
    getCouponCode: async (data: {
      store_id: number;
      parent_store_id: number;
      user_token_id: number;
      price: number;
      coupon_code: string;
    }): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getCouponCode";

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getCouponCode] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getCouponCode] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getKnockMain: async (
      user_id: number,
      user_token_id: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getKnockMain";

        const response: any = await Axios.post(sUrl, {
          user_id,
          user_token_id,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getKnockMain] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getKnockMain] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getStoreStatus: async (user_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getStoreStatus";

        const response: any = await Axios.post(sUrl, {
          user_id,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getStoreStatus] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getStoreStatus] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getAdverList: async (
      user_id: number,
      user_token_id: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getAdverList";

        const response: any = await Axios.post(sUrl, {
          user_id,
          user_token_id,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getAdverList] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getAdverList] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getKnockStoreData: async (data: {
      user_token_id: number;
      store_id: number;
      parent_store_id: number;
      user_id: number;
    }): Promise<AxiosResponse | undefined> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getKnockStoreData`;
        const response: AxiosResponse = await Axios.post(sUrl, data);

        return response;
      } catch (err: any) {
        console.error("ERROR [store/getKnockStoreData] : ", err);
      }
    },

    getStoreWebOrderData: async (
      user_id: number,
      store_id: number,
      parent_store_id: number,
      user_token_id: number,
      price: number,
      number: number,
      area_number: number
    ): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/store/getStoreWebOrderData`;
        const response: AxiosResponse = await Axios.post(sUrl, {
          user_id,
          store_id,
          parent_store_id,
          user_token_id,
          price,
          number,
          area_number,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getStoreWebOrderData] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getStoreWebOrderData] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getAreaInfo: async (
      user_id: number,
      area_number: number,
      number: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getAreaInfo`;
        const response: AxiosResponse = await Axios.post(sUrl, {
          user_id,
          area_number,
          number,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getAreaInfo] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getAreaInfo] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    storeInfo: async (user_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/storeInfo`;
        const response: AxiosResponse = await Axios.post(sUrl, {
          user_id,
        });
        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/storeInfo] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/storeInfo] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    // 호텔소개, 할인권소개 카드 내용 불러오기
    getAroundCard: async (user_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getAroundCard";

        const response: any = await Axios.post(sUrl, {
          user_id,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getAroundCard] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getAroundCard] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getCardContent: async (
      card_id: number,
      lang: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getCardContent";

        const response: any = await Axios.post(sUrl, {
          card_id,
          lang,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getCardContent] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getCardContent] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    // 매장 할인권 발송
    sendVoucher: async (
      voucher_id: number,
      parent_store_id: number,
      user_token_id: number,
      send_type: number,
      receiver_data: string,
      lang: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/sendVoucher";
        const data = {
          voucher_id: voucher_id,
          parent_store_id: parent_store_id,
          user_token_id: user_token_id,
          send_type: send_type,
          receiver_data: receiver_data,
          lang: lang,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/sendVoucher] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/sendVoucher] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getEventList: async (
      user_id: number,
      user_token_id: number
    ): Promise<Response> => {
      try {
        const oParams = {
          user_id,
          user_token_id,
        };
        let sUrl = process.env.REACT_APP_API_URL + `/store/getEventList`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[이벤트 불러오기 오류]" + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    setEventCoupon: async (
      event_id: number,
      user_id: number,
      user_token_id: number,
      coupon_id?: number
    ): Promise<Response> => {
      try {
        const oParams = {
          event_id,
          user_id,
          user_token_id,
          coupon_id,
        };
        let sUrl = process.env.REACT_APP_API_URL + `/store/setEventCoupon`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[이벤트 쿠폰 받기 오류]" + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  menu: {
    getOptions: async (productId: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/menu/getOptions`;
        const data = {
          product_id: productId,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [menu/getOptions] : ", err);

        return {
          ok: false,
          msg: "ERROR [menu/getOptions] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getSetOptions: async (
      productId: number,
      storeId: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/menu/getSetOptions`;
        const data = {
          store_id: storeId,
          set_product_id: productId,
        };
        const response: any = await Axios.post(sUrl, data);
        return response.data;
      } catch (err: any) {
        console.error("ERROR [menu/getSetOptions] : ", err);

        return {
          ok: false,
          msg: "ERROR [menu/getSetOptions] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  order: {
    testKnock: async (store_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/test/knock`;
        const data = {
          store_id,
        };

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [/order/test/knock]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getOrderByOrderId: async (order_id: string): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/getOrderByOrderId`;
        const data = {
          order_id,
        };

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getOrderByOrderId]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getOrderByUserTokenId: async (): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/order/getOrderByUserTokenId`;
        const data = {
          user_token_id: getRecoil(qrAuthState).user_token_id,
          // user_token_id: 3992,
        };

        const response: any = await Axios.post(sUrl, data);

        console.log("getOrderByUserTokenId", response.data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getOrderByUserTokenId]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    cancelCustomer: async (
      order_id: string,
      order_seq: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/cancelCustomer`;
        const data = {
          order_id,
          order_seq,
        };

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/cancelCustomer]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    products: async (data: RequestOrderProudctType): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/order/products";

        const response: AxiosResponse = await Axios.post(sUrl, data);

        // if(getResponseValidation(response)){
        return response.data;
        // }else{
        //   return {
        //     ok: false,
        //     msg: "ERROR [order/products] : ",
        //     data: undefined,
        //     status: 500,
        //   };
        // }
      } catch (err: any) {
        console.error("ERROR [order/products] : ", err);

        return {
          ok: false,
          msg: "ERROR [order/products] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    setReview: async (data: any): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/order/setReview";
        const response: AxiosResponse = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [order/setReview] : ", err);

        return {
          ok: false,
          msg: "ERROR [order/setReview] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  auth: {
    signin: async (params: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/auth/signin`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[로그인 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    signinClient: async (params: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/auth/signinClient`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[qr 로그인 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
  },

  //getStoreData가져오기
  getMenuByStoreLoginId: async (storeId: string): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + `/store/getStoreData`;
      const data = {
        store_id: storeId,
      };

      const response: any = await Axios.post(sUrl, data);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[메뉴 불러오기 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  area: {
    // 기기 객실 정보 불러오기
    getAreaByUserToken: async (storeId: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getAreaByUserToken`;
        const data = {
          user_token_id: getRecoil(qrAuthState).user_token_id,
          store_id: storeId,
        };

        const response: any = await Axios.post(sUrl, data);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[기기 객실 정보 불러오기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    // 구역 불러오기
    getArea: async (storeId: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getArea`;
        const data = {
          store_id: storeId,
        };

        const response: any = await Axios.post(sUrl, data);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[구역 불러오기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    // 구역 설정하기
    setArea: async (
      storeId: number,
      area_number: number | null,
      number: number | null
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/setArea`;
        const data = {
          store_id: storeId,
          user_token_id: getRecoil(qrAuthState).user_token_id,
          area_number: area_number,
          number: number,
        };

        const response: any = await Axios.post(sUrl, data);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[구역 설정하기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  user: {
    getCard: async (client_user_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/user/getCard`;
        const data = {
          client_user_id,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[카드 불러오기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    setCard: async (
      client_user_id: number,
      exp_year: string,
      exp_month: string,
      id_no: string,
      card_no: string,
      card_pw: string
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/pay/nice/regist`;
        const data = {
          client_user_id,
          exp_year,
          exp_month,
          id_no,
          card_no,
          card_pw,
        };
        const response: any = await Axios.post(sUrl, data);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[카드 등록 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    checkPayment: async (client_user_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/user/checkPayment`;
        const data = {
          client_user_id,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[비밀번호 최초여부 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    setPaymentPassword: async (
      client_user_id: number,
      password: string
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/user/setPaymentPassword`;
        const data = {
          client_user_id,
          password,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[비밀번호 설정 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    checkPaymentPassword: async (
      client_user_id: number,
      password: string
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/user/checkPaymentPassword`;
        const data = {
          client_user_id,
          password,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[비밀번호 검증 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    billing: async (
      ccard_id: number,
      order_id: string,
      order_seq: number,
      client_user_id: number,
      password: string
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/pay/nice/billing`;
        const data = {
          ccard_id,
          order_id,
          order_seq,
          client_user_id,
          password,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[간편결제 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    sendSms: async (phone_number: string): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/user/sendSms`;
        const data = {
          phone_number,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[인증번호 전송 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    verifySmsAndRegisterUser: async (auth_code: string): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/user/verifySmsAndRegisterUser`;
        const data = {
          auth_code,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[인증번호 확인 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    setWebFirebaseToken: async (sFirebaseToken: string): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/user/setWebFirebaseToken`;
        const data = {
          firebase_token: sFirebaseToken,
        };
        const response: any = await Axios.post(sUrl, data);
        console.log("setWebFirebaseToken", response);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[Firebase Token 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },
};

const getResponseValidation = (res: AxiosResponse) => {
  if (res.status === 200) {
    const response: Response = res.data.data;

    if (response.ok) {
      return true;
    } else {
      return false;
    }
  }

  return false;
};

export default ApiController;
